// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PostGrid--wrapper--2Ge5l"};